// @mui
import { styled } from '@mui/material/styles';
import { Typography, Container } from '@mui/material';
// components
import Page from '../../components/Page';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column'
}));

// ----------------------------------------------------------------------

export default function ComingSoon() {
  return (
    <Page title="Coming Soon">
      <Container>
        <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            Coming Soon
          </Typography>
        </ContentStyle>
      </Container>
    </Page>
  );
}
